module.exports = __webpack_public_path__ + "static/media/StudentContent3.9783e8c3.svg";